import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useStyles } from './styles';

interface RBIFollowCursorTooltipProps {
  title: string;
  children: React.ReactNode;
  disabled?: boolean;
}

const RBIFollowCursorTooltip: React.FC<RBIFollowCursorTooltipProps> = ({
  title,
  children,
  disabled = false,
}) => {
  const classes = useStyles();
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (tooltipRef.current) {
      tooltipRef.current.style.display = isVisible ? 'block' : 'none';
    }
  }, [isVisible]);

  const handleMouseMove = (e: React.MouseEvent) => {
    setPosition({ x: e.clientX, y: e.clientY });
    if (!isVisible && title) {
      setIsVisible(true);
    }
  };

  const handleMouseOut = () => {
    setIsVisible(false);
  };

  return (
    <div
      ref={containerRef}
      className={`${classes.followCursorTooltip} ${
        disabled ? classes.disabled : ''
      }`}
      onMouseMove={handleMouseMove}
      onMouseOut={handleMouseOut}
    >
      {children}
      {createPortal(
        <div
          ref={tooltipRef}
          className={`MuiTooltip-tooltip ${isVisible ? 'visible' : ''}`}
          style={{
            position: 'fixed',
            left: position.x + 10,
            top: position.y + 10,
          }}
        >
          {title}
        </div>,
        document.body,
      )}
    </div>
  );
};

export default RBIFollowCursorTooltip;
